import conf from "../config/conf.json";
import {createContext, useContext} from "react";
import {UsersClient} from "./parts/UsersClient";
import {AccessTokenPayload, RestClient} from "zavadil-ts-common";
import {AccessTokenManager} from "./AccessTokenManager";
import {TermsPayload} from "../types/TermsPayload";
import {RolesClient} from "./parts/RolesClient";
import {ContactTypesClient} from "./parts/ContactTypesClient";
import {ContactsClient} from "./parts/ContactsClient";
import {RegionsClient} from "./parts/RegionsClient";
import {ContactSourcesClient} from "./parts/ContactSourcesClient";
import {TargetGroupsClient} from "./parts/TargetGroupsClient";
import {NodesClient} from "./parts/NodesClient";
import {ScraperClient} from "./parts/ScraperClient";
import {ImportClient} from "./parts/ImportClient";
import {CheckClient} from "./parts/CheckClient";

export class SpmRestClient extends RestClient {

	tokenManager: AccessTokenManager;

	anonymousClient: RestClient;

	users: UsersClient;

	roles: RolesClient;

	regions: RegionsClient;

	contactTypes: ContactTypesClient;

	contactSources: ContactSourcesClient;

	targetGroups: TargetGroupsClient;

	contacts: ContactsClient;

	nodes: NodesClient;

	scraper: ScraperClient;

	import: ImportClient;

	check: CheckClient;

	constructor(onLogout: () => any) {
		super(conf.API_URL);

		this.tokenManager = new AccessTokenManager(conf.API_URL, onLogout);
		this.anonymousClient = new RestClient(conf.API_URL);

		this.users = new UsersClient(this);
		this.roles = new RolesClient(this);
		this.regions = new RegionsClient(this);
		this.contactTypes = new ContactTypesClient(this);
		this.contactSources = new ContactSourcesClient(this);
		this.targetGroups = new TargetGroupsClient(this);
		this.contacts = new ContactsClient(this);
		this.nodes = new NodesClient(this);
		this.scraper = new ScraperClient(this);
		this.import = new ImportClient(this);
		this.check = new CheckClient(this);
	}

	getHeaders(endpoint: string): Promise<Headers> {
		return this.tokenManager.getAccessTokenRaw()
			.then((accessToken) =>
				super.getHeaders(endpoint).then((headers) => {
					headers.set("Authorization", `Bearer ${accessToken}`);
					return headers;
				}),
			);
	}

	initialize(): Promise<AccessTokenPayload> {
		return this.tokenManager.initialize();
	}

	logIn(login: string, password: string): Promise<AccessTokenPayload> {
		return this.tokenManager.logIn(login, password);
	}

	logOut() {
		return this.tokenManager.logOut();
	}

	version(): Promise<string> {
		return this.get("status/version").then((r) => r.text());
	}

	terms(): Promise<TermsPayload> {
		return this.anonymousClient.getJson("terms");
	}

}

export const SpmRestClientContext = createContext<SpmRestClient | undefined>(undefined);

export function useRestClient(): SpmRestClient {
	const ctx = useContext(SpmRestClientContext);
	if (!ctx) throw new Error("useRestClient must be used within App!");
	return ctx;
}
